<template>
  <div class="main-view">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form :inline="true" class="inline-form">
          <el-form-item label="提交时间">
            <el-date-picker
              v-model="useTime"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="流水号">
            <el-input class="search-input" v-model="subsidyId" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width: 120px;" v-model="handleStatus" clearable>
              <el-option label="待确认" value="0"></el-option>
              <el-option label="待校验" value="1"></el-option>
              <el-option label="校验不通过" value="2"></el-option>
              <el-option label="待处理" value="3"></el-option>
              <el-option label="确认废弃" value="4"></el-option>
              <el-option label="处理成功" value="5"></el-option>
              <el-option label="处理失败" value="6"></el-option>
              <el-option label="校验通过" value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 补贴列表table -->
      <el-table
        stripe
        style="width:100%;"
        :data="subsidyList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + 1"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="fCreateTime"
          label="提交时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fSubsidyId"
          label="流水号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fSubsidyDate"
          label="补贴日期"
          align="center"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="fServiceTotalFee"
          label="手续费补贴金额(元)"
          align="center"
          min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.fServiceTotalFee | formatAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fMarketingTotalFee"
          label="营销补贴金额(元)"
          align="center"
          min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.fMarketingTotalFee | formatAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fSubsidyTotalFee"
          label="补贴总金额(元)"
          align="center"
          min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.fSubsidyTotalFee | formatAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fMerchantCount"
          label="补贴商户数"
          align="center"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="fHandleStatus"
          label="状态"
          align="center"
          min-width="120">
          <template slot-scope="scope">
            <div>{{ scope.row.fHandleStatus | formatHandleStatus }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fReason"
          label="备注"
          align="center"
          min-width="120">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="200">
          <template slot-scope="scope">
            <auth-button
              opt="confirm"
              type="text"
              v-if="scope.row.fHandleStatus === 0"
              label="确认"
              @click.native="handleConfrim(scope.$index, scope.row)"></auth-button>
            <auth-button
              opt="details"
              type="text"
              label="明细"
              @click.native="handleDetail(scope.$index, scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.count > 0"
        class="pagination"
        :page-size="paginations.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="paginations.count"
        :current-page="paginations.pageNo"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <!-- 补贴明细dialog -->
    <el-dialog
      :visible.sync="subsidyDetailDialogVisible"
      width="80%">
      <div style="display: inline-block;width: 100%;" v-loading="subsidyDetailDialogLoading">
        <div>
          <el-col>
            <el-form :inline="true" class="inline-form">
              <el-form-item label="商户编号">
                <el-input class="search-input" v-model="detailMerchantId" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item>
                <auth-button opt="search_details" icon="el-icon-search" @click.native="detailsearchClick" label="查询"></auth-button>
                <auth-button opt="export" icon="el-icon-download" @click.native="exportAgentSubsidyFileDetail" label="导出"></auth-button>
                <a ref="exportSubsidyFile" v-show="false"></a>
              </el-form-item>
            </el-form>
          </el-col>
        </div>
        <div>
          <el-table
            border
            show-summary
            :summary-method="getSummaries"
            style="width:100%;"
            :data="subsidyDetailList"
            max-height="490">
            <el-table-column
              type="index"
              label="序号"
              :index="index => index + 1"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="fDetailId"
              label="流水号"
              align="center"
              min-width="200">
            </el-table-column>
            <el-table-column
              prop="fMerchantId"
              label="商户编号"
              align="center"
              min-width="200">
            </el-table-column>
            <el-table-column
              prop="fMerchantName"
              label="商户名称"
              align="center"
              min-width="150">
            </el-table-column>
            <el-table-column
              prop="fServiceFee"
              label="手续费补贴金额(元)"
              align="center"
              min-width="180">
              <template slot-scope="scope">
                <div>{{ scope.row.fServiceFee | formatAmount }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="fMarketingFee"
              label="营销补贴金额(元)"
              align="center"
              min-width="180">
              <template slot-scope="scope">
                <div>{{ scope.row.fMarketingFee | formatAmount }}</div>
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="24" class="btm-action">
            <el-pagination
              v-if="detailPaginations.count > 0"
              class="pagination"
              :page-size="detailPaginations.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="detailPaginations.count"
              :current-page="detailPaginations.pageNo"
              @current-change="onDetailChangeCurrentPage">
            </el-pagination>
          </el-col>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="补贴文件确认"
      :visible.sync="subsidyConfrimDialogVisible"
      width="400px">
      <div style="text-align: center;">
        <el-button type="primary" @click="confirmDestroySubsidyFile('1')">确认无误</el-button>
        <el-button type="danger" @click="confirmDestroySubsidyFile('4')">废弃</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { subsidyInfo, subsidyInfoDetail, confirmDestroySubsidy, exportSubsidyFileDetail } from '@/api/activity'
export default {
  name: 'SubsidyFile',
  components: {},
  data () {
    return {
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            const end = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        FStartTime: '',
        FEndTime: '',
        FSubsidyId: '',
        FHandleStatus: ''
      },
      useTime: '',
      subsidyId: '',
      handleStatus: '',
      subsidyList: [],
      subsidyDetailDialogVisible: false,
      subsidyDetailDialogLoading: false,
      detailSubsidyInfo: {},
      // 明细分页组件传的信息
      detailPaginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 明细搜索表单信息
      detailSearchInfo: {
        FMerchantSubsidyId: '',
        FMerchantId: ''
      },
      detailMerchantId: '',
      subsidyDetailList: [],
      subsidyConfrimDialogVisible: false
    }
  },
  mounted () {
    this.searchClick()
  },
  methods: {
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * 合计计算方法
     */
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (column.label === '手续费补贴金额(元)' || column.label === '营销补贴金额(元)' || column.label === '原结算金额(元)' || column.label === '最终结算金额金额(元)') {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
          } else {
            sums[index] = 'N/A'
          }
        }
      })
      sums.forEach((element, index) => {
        if (element && !isNaN(element)) {
          sums[index] = parseFloat(element / 100).toFixed(2)
        }
      })
      return sums
    },
    /**
     * 筛选查询按钮点击
     */
    searchClick (noReset) {
      this.searchInfo.FStartTime = this.useTime && this.useTime[0] ? this.useTime[0] : ''
      this.searchInfo.FEndTime = this.useTime && this.useTime[1] ? this.useTime[1] : ''
      this.searchInfo.FSubsidyId = this.subsidyId || ''
      this.searchInfo.FHandleStatus = this.handleStatus || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      this.searchInfo = Object.assign(this.searchInfo, this.paginations)
      this.listSubsidyInfo()
    },
    /**
     * 删除提交参数中的空字段
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 确认按钮按钮点击
     */
    handleConfrim (index, row, scope) {
      this.detailSubsidyInfo = row
      this.subsidyConfrimDialogVisible = true
    },
    /**
     * 记录明细按钮点击
     */
    handleDetail (index, row, scope) {
      this.detailSubsidyInfo = row
      this.FMerchantId = ''
      this.detailsearchClick()
      this.subsidyDetailDialogVisible = true
    },
    /**
     * 明细列表改变当前页事件
     * @param  {number} page 当前页码
     */
    onDetailChangeCurrentPage (page) {
      this.detailPaginations.pageNo = page
      this.detailsearchClick(true)
    },
    /**
     * 明细列表筛选查询按钮点击
     */
    detailsearchClick (noReset) {
      this.detailSearchInfo.FMerchantSubsidyId = this.detailSubsidyInfo.fSubsidyId || ''
      this.detailSearchInfo.FMerchantId = this.detailMerchantId || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.detailPaginations.pageNo = 1
        this.detailPaginations.count = 0
      }
      this.detailSearchInfo = Object.assign(this.detailSearchInfo, this.detailPaginations)
      this.listSubsidyInfoDetail()
    },
    /**
     * 补贴文件列表
     */
    listSubsidyInfo () {
      const params = qs.stringify(this.searchInfo)
      subsidyInfo(params).then(response => {
        if (response.error_code === '0') {
          this.subsidyList = response.data.list
          this.paginations.count = response.data.totalCount
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 补贴文件详情
     */
    listSubsidyInfoDetail () {
      this.subsidyDetailDialogLoading = true
      const params = qs.stringify(this.detailSearchInfo)
      subsidyInfoDetail(params).then(response => {
        this.subsidyDetailDialogLoading = false
        if (response.error_code === '0') {
          this.subsidyDetailList = response.data.list
          this.detailPaginations.count = response.data.totalCount
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 确认或废弃 代理商补贴文件
     */
    confirmDestroySubsidyFile (status) {
      this.loading = true
      const params = qs.stringify({
        FSubsidyId: this.detailSubsidyInfo.fSubsidyId,
        FHandleStatus: status
      })
      confirmDestroySubsidy(params).then(response => {
        this.loading = false
        if (response.error_code === '0') {
          this.$message({
            message: `${status === '1' ? '确认' : '废弃'}成功!`,
            type: 'success'
          })
          this.subsidyConfrimDialogVisible = false
          this.searchClick(true)
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 补贴文件详情 导出
     */
    exportAgentSubsidyFileDetail () {
      this.subsidyDetailDialogLoading = true
      const params = qs.stringify(this.detailSearchInfo)
      exportSubsidyFileDetail(params).then(response => {
        const url = URL.createObjectURL(new Blob([response]))
        const link = this.$refs.exportSubsidyFile
        link.href = url
        link.setAttribute('download', '补贴文件详情.csv')
        link.click()
        this.subsidyDetailDialogLoading = false
        this.$message({
          message: '导出成功!',
          type: 'success'
        })
      })
    }
  },
  computed: {},
  filters: {
    formatHandleStatus (value) {
      switch (value) {
        case 0:
          return '待确认'
        case 1:
          return '待校验'
        case 2:
          return '校验不通过'
        case 3:
          return '待处理'
        case 4:
          return '确认废弃'
        case 5:
          return '处理成功'
        case 6:
          return '处理失败'
        case 7:
          return '校验通过'
        default:
          return '未知'
      }
    },
    formatAmount (value) {
      return (!value && parseInt(value) !== 0) ? '--' : parseFloat(parseFloat(value).toFixed(2) / 100).toFixed(2)
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.entry-dialog-form-item {
  width: 260px;
}
.info-dialog-form-item {
  width: 260px;
  margin-right: 30px;
}
</style>
